import { render, staticRenderFns } from "./AverageDaysOfStock.vue?vue&type=template&id=1a090c0e"
import script from "./AverageDaysOfStock.vue?vue&type=script&lang=js"
export * from "./AverageDaysOfStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports